import { useEffect, useState } from 'react';
import { Dimension, Product } from '@inter-ikea-storageone/range';
import { SelectedProduct } from 'ducks/products';
import { FilterOption, getUnit } from 'filters/SizeFilter/utils';
import SizeToggle from 'ui/SizeToggle/SizeToggle';

const Height = ({
  title,
  products,
  selectedProduct,
  onSizeChange,
  sectionsWithSameDepth,
  availableHeights
}: {
  title?: string;
  fluidWidth?: boolean;
  products: Product[];
  selectedProduct: SelectedProduct | null;
  onSizeChange: (
    size: number,
    setFilterState: any,
    sectionsMatchingSelectedSection: any,
    dimensionType: Dimension
  ) => void;
  sectionsWithSameDepth: Product[];
  availableHeights: FilterOption;
}) => {
  const [filterState, setFilterState] = useState({ selected: 0 });

  // Get the current markets unit
  const unit = getUnit(products);

  // Set the checked height to current selected products height
  useEffect(() => {
    if (selectedProduct) {
      setFilterState({ selected: selectedProduct?.communicatedDimensions.height });
    }
  }, [selectedProduct, selectedProduct?.communicatedDimensions]);

  if (!selectedProduct) return null;
  const sizes = Object.entries(availableHeights).map(([size, communicated]) => {
    return { value: parseInt(size, 10), text: `${communicated}`, unit: `${unit}` };
  });
  const currentSize = filterState.selected;

  return sizes.length > 0 ? (
    <SizeToggle
      title={title}
      disabled={sizes.length === 1}
      data-testid="change-height"
      sizes={sizes}
      currentSize={currentSize}
      onChangeSize={size => {
        if (size !== currentSize) {
          onSizeChange(size, setFilterState, sectionsWithSameDepth, 'height');
        }
      }}
    />
  ) : (
    <></>
  );
};

export default Height;
